<div class="overlay-spinner" *ngIf="showSpinner">
    <div [ngClass]="{ 'overlay-block': true, show: showSpinnerBlock }">
        <div class="overlay"></div>
        <div class="spinner">
            <div class="spinner-content">
                <img src="assets/image/loader.gif">           
            </div>
        </div>        
    </div>
</div>